<div class="ap-container">
  <gstar-extended-editor
    #editor
    [title]="title"
    [content]="description"
    [mode]="mode()"
    [canEdit]="canEditCountry()"
    [showReadOnlyLabel]="showReadOnlyLabel()"
    [allowInternalLinks]="true"
    (modeChange)="modeUpdate($event)"
    (dismiss)="cancelHandler()"
    (save)="save($event)">
    @if (countryInfo()?.reviewDate) {
      <ng-container toolbar>
        <div class="review-date-display">
          <span class="review-date-display-label">
            {{ 'shared.lastReviewDate' | translate }}
          </span>
          <span class="review-date-display-value">
            {{
              countryInfo()?.reviewDate
                ? (countryInfo()?.reviewDate | date: 'dd MMMM yyyy')
                : '-'
            }}
          </span>
        </div>
      </ng-container>
    }
    <ng-container toolbar-edit>
      <form [formGroup]="reviewDateForm" class="mb-0 review-date-form">
        <gstar-datepicker
          [value]="reviewDateValue()"
          [disabled]="isReviewDateDisabled()"
          [label]="'shared.lastReviewDate' | translate"
          formControlName="reviewDate" />
      </form>
    </ng-container>
  </gstar-extended-editor>
</div>
